import { FieldInput } from './field-input';
import { type FieldInputProps } from './types';
import { useBufferedValue } from './use-buffered-value';

/**
 * Free-text buffers locally and flushes on blur/unmount; every other input
 * kind commits immediately.
 */
export function BufferedFieldInput({ onChange, ...props }: FieldInputProps) {
  const isText = props.descriptor.kind === 'text';
  const buffered = useBufferedValue(typeof props.value === 'string' ? props.value : '', (next) =>
    onChange(next),
  );

  if (isText) {
    return (
      <FieldInput
        {...props}
        value={buffered.value}
        onChange={(next) => buffered.onChange(typeof next === 'string' ? next : '')}
        onBlur={buffered.onBlur}
      />
    );
  }
  return <FieldInput {...props} onChange={onChange} />;
}
